import loginStateService from "../services/login-state.service";
import { signInWithRedirect } from "aws-amplify/auth";

interface RedirectToOAuthLoginParams {
  identityProvider: string;
  stateData: any;
}

const redirectToOAuthLogin = ({
  identityProvider,
  stateData
}: RedirectToOAuthLoginParams): void => {
  const state = loginStateService.saveState(stateData);

  signInWithRedirect({
    provider: { custom: identityProvider },
    customState: state
  });
};

export default redirectToOAuthLogin;
